module.exports = __webpack_public_path__ + "static/5-9e39e2471e515466441c7e214e55f96d.jpg";